<!-- eslint-disable max-len -->
<template>
  <div class="my-4 mx-16 bg-white rounded text-gray-800">
    <div style="break-after: page;">
      <div class="d-flex justify-content-between">
        <div class="float-left text-2xl text-blue-800 font-bold">
          <span class="inline-block align-text-bottom">Transfer Balance Cap</span>
          <hr class="border-4 border-teal-600 w-4/6" />
        </div>
        <div class="float-right mr-auto">
        <svg width="142" height="34" viewBox="0 0 142 34" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M54.7833 5.23322V14.1417H42.449V5.23322H39.8507V27.8147H42.449V16.5879H54.7833V27.8147H57.3756V5.23322H54.7833Z" fill="#053C72"/>
          <path d="M91.3178 8.83556C91.3178 7.44209 92.2975 7.15001 93.1251 7.15001C93.6301 7.15001 94.0257 7.26562 94.2995 7.49077L94.476 7.63681L95.766 5.62875L95.6078 5.51314C94.9202 5.01417 94.0378 4.73425 93.1251 4.73425C90.4903 4.73425 88.7256 6.38329 88.7256 8.84164V10.296H88.1354H86.7176H83.0483V8.84164C83.0483 7.44817 84.028 7.15609 84.8555 7.15609C85.3606 7.15609 85.7561 7.27171 86.03 7.49685L86.2064 7.6429L87.4964 5.63484L87.3382 5.51922C86.6506 5.02025 85.7683 4.74034 84.8555 4.74034C82.2207 4.74034 80.4561 6.38938 80.4561 8.84773V10.302H78.0647V12.7482H80.4561V27.8269H83.0544V12.7361H86.7236H88.1415H88.7317V27.8147H91.33V12.7361H95.6504V10.2899H91.33V8.83556H91.3178Z" fill="#053C72"/>
          <path d="M115.342 9.78485C110.145 9.78485 105.91 13.9348 105.91 19.0341C105.91 24.1516 110.139 28.3137 115.342 28.3137C120.544 28.3137 124.774 24.1516 124.774 19.0341C124.774 13.9348 120.544 9.78485 115.342 9.78485ZM122.114 19.0341C122.114 20.8718 121.415 22.5999 120.149 23.8899C118.877 25.186 117.167 25.898 115.342 25.898C111.606 25.898 108.569 22.819 108.569 19.0341C108.569 15.2675 111.606 12.2006 115.342 12.2006C119.078 12.2006 122.114 15.2675 122.114 19.0341Z" fill="#053C72"/>
          <path d="M140.193 11.7564C138.97 10.4664 137.193 9.78485 135.057 9.78485C132.653 9.78485 130.438 11.2027 129.404 12.73V10.2899H126.806V27.8148H129.404V17.0564C129.404 14.3243 132.349 12.2067 134.874 12.2067C137.582 12.2067 139.402 14.0626 139.402 16.8252V27.8208H142V16.8191C142.006 14.7502 141.379 12.9977 140.193 11.7564Z" fill="#053C72"/>
          <path d="M107.455 10.5028C107.394 10.4663 106.165 9.79694 104.431 9.77869H104.37C104.352 9.77869 104.327 9.77869 104.309 9.77869H104.23C102.277 9.83345 100.823 11.0444 99.9889 12.3344V10.2837H97.3905V27.8086H99.9889V16.8495C99.9889 14.379 101.979 12.2796 104.34 12.2675C104.595 12.2675 104.851 12.2918 105.094 12.3466L105.155 12.3587C105.258 12.3831 105.356 12.4074 105.459 12.4378L105.514 12.4561C105.636 12.4926 105.745 12.5352 105.849 12.5778C105.989 12.6386 106.013 12.6082 106.305 12.2675C106.439 12.1093 107.553 10.7462 107.589 10.6914C107.644 10.6184 107.522 10.5393 107.455 10.5028Z" fill="#053C72"/>
          <path d="M68.6208 9.78485C63.4729 9.78485 59.2803 13.9348 59.2803 19.0341C59.2803 24.1516 63.4729 28.3137 68.6208 28.3137C70.0812 28.3137 71.493 27.9608 72.8134 27.2671C74.1947 26.5613 75.3935 25.5025 76.2758 24.2063L76.3245 24.1333C76.3792 24.0481 76.434 23.9629 76.4888 23.8778C76.507 23.8534 76.5253 23.823 76.5375 23.7987C76.5679 23.75 76.5983 23.7074 76.6287 23.6587L76.72 23.4944H76.7139C76.8721 23.2084 77.0242 22.9042 77.1581 22.5877L77.2372 22.3991L74.9979 21.4681L74.9188 21.6567C74.8093 21.9184 74.6998 22.1496 74.5842 22.3504C73.3489 24.5715 71.1157 25.898 68.6087 25.898C65.2984 25.898 62.5236 23.5492 61.9273 20.2754H77.8518L77.8822 20.105C77.9431 19.7765 77.9735 19.4053 77.9735 19.0341C77.9918 13.9348 73.7931 9.78485 68.6208 9.78485ZM75.3326 17.8292H61.9456C62.5419 14.6042 65.3714 12.2067 68.6208 12.2067C71.8946 12.2006 74.7363 14.6042 75.3326 17.8292Z" fill="#053C72"/>
          <path d="M16.6182 8.9145C23.2204 8.9145 28.6726 13.9894 28.5387 20.9628C28.411 27.5955 23.3117 33.0355 16.6304 33.0355C7.49675 33.0355 0 25.5935 0 16.4112C0 16.4112 0.632843 27.9241 11.8658 28.2953C18.462 28.5144 24.1271 23.0257 24.1271 16.4295V16.4112C24.1271 13.8616 23.0257 12.2065 22.0704 11.2512C19.4903 8.67719 16.6182 8.9145 16.6182 8.9145Z" fill="url(#paint0_linear)"/>
          <path d="M8.98782 16.4478C8.98782 9.86379 14.0506 4.36902 20.9996 4.56374C28.2652 4.76454 33.0358 9.77252 33.0358 16.4417C33.0358 25.551 25.6182 33.0234 16.4663 33.0234C16.4663 33.0234 27.9427 32.3905 28.3138 21.188C28.5329 14.6101 23.0625 8.96321 16.4846 8.96321H16.4663C13.9228 8.96321 12.2798 10.0585 11.3184 11.0139C8.7505 13.5878 8.98782 16.4478 8.98782 16.4478Z" fill="url(#paint1_linear)"/>
          <path d="M16.4599 23.975C9.882 23.975 4.44808 18.9305 4.58195 11.9997C4.70974 5.40958 9.79073 0 16.4538 0C25.557 0 33.0355 7.33245 33.0355 16.5147C33.0355 16.5147 33.1694 5.12967 21.1941 4.70372C14.6222 4.47249 8.97534 9.93684 8.97534 16.4965V16.5147C8.97534 19.0461 10.0706 20.6891 11.026 21.6444C13.6 24.2123 16.4599 23.975 16.4599 23.975Z" fill="url(#paint2_linear)"/>
          <path d="M24.1393 16.5018C24.1393 23.0553 19.0583 28.331 12.0788 28.331C5.25137 28.331 0 23.1466 0 16.5139C0 7.45333 7.44806 0.0113525 16.6304 0.0113525C16.6304 0.0113525 5.11141 0.638111 4.73414 11.7859C4.51508 18.3333 10.0038 23.9498 16.6121 23.9498H16.6304C19.18 23.9498 20.8351 22.8606 21.7965 21.9053C24.3766 19.3495 24.1393 16.5018 24.1393 16.5018Z" fill="url(#paint3_linear)"/>
          <defs>
            <linearGradient id="paint0_linear" x1="4.15211" y1="28.0453" x2="27.0315" y2="14.8358" gradientUnits="userSpaceOnUse">
              <stop offset="0" stop-color="#053C72"/>
              <stop offset="0.2227" stop-color="#16678B"/>
              <stop offset="0.4528" stop-color="#248DA1"/>
              <stop offset="0.6665" stop-color="#2EA8B0"/>
              <stop offset="0.8556" stop-color="#35B8BA"/>
              <stop offset="1" stop-color="#37BEBD"/>
            </linearGradient>
            <linearGradient id="paint1_linear" x1="8.96323" y1="13.8413" x2="31.323" y2="23.7964" gradientUnits="userSpaceOnUse">
              <stop offset="0" stop-color="#053C72"/>
              <stop offset="1" stop-color="#37BEBD"/>
            </linearGradient>
            <linearGradient id="paint2_linear" x1="28.904" y1="4.94797" x2="6.0984" y2="18.1149" gradientUnits="userSpaceOnUse">
              <stop offset="0" stop-color="#053C72"/>
              <stop offset="0.2237" stop-color="#16688B"/>
              <stop offset="0.4535" stop-color="#248DA0"/>
              <stop offset="0.667" stop-color="#2EA8B0"/>
              <stop offset="0.8558" stop-color="#34B9B9"/>
              <stop offset="1" stop-color="#37BEBD"/>
            </linearGradient>
            <linearGradient id="paint3_linear" x1="24.1255" y1="19.1268" x2="1.72973" y2="9.1555" gradientUnits="userSpaceOnUse">
              <stop offset="0" stop-color="#053C72"/>
              <stop offset="1" stop-color="#37BEBD"/>
            </linearGradient>
          </defs>
        </svg>
        </div>
      </div>
      <div class="float-left w-full mb-6">
        <p class="mt-4" v-if="name !== ''">Transfer Balance Cap calculation prepared for {{ name }}</p>
        <div class="w-full mt-2 text-xs">
          <p>Indexation calculation prepared on {{ preparedOn | moment('D MMM YYYY') }}</p>
        </div>
        <h2 class="font-bold text-gray-900 pb-1 mt-4">Indexation Calculation</h2>
        <hr class="w-full border-2">
        <div class="w-full mt-4 text-xs">
          <table class='w-full border'>
            <thead class='font-bold'>
            <tr>
              <td class='text-center border'>Indexation Date</td>
              <td class='text-center border'>Highest Used Cap % <br />(Lowest Unused Cap %)</td>
              <td class='text-center border'>Based on</td>
              <td class='text-center border'>Indexation applicable</td>
              <td class='text-center border'>Personal Transfer <br />Balance Cap</td>
            </tr>
            </thead>
            <tr id='indexation' v-for='indexation in indexations' :key='indexation.id'>
              <td class='text-left pl-4'>{{ indexation.startDate | moment('D MMM YYYY') }}</td>
              <td class='text-center px-4'>{{ indexation.ratio | percent }}</td>
              <td class='text-right px-4'>{{ indexation.maxTBA | dollar }} <br />
                <div v-if='indexation.maxTBADate'>({{ indexation.maxTBADate | moment('D MMM YYYY') }})</div>
              </td>
              <td class='text-right px-4'>{{ indexation.indexation | dollar }}</td>
              <td class='text-right px-4'>{{ indexation.tbc | dollar }}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="float-left w-full">
        <h2 class="font-bold text-gray-900 pb-1 mt-4">Transfer Balance Account Transaction Data</h2>
        <hr class="w-full border-2">
        <table class='mt-4 table-auto w-full border text-xs'>
          <thead class='font-bold '>
          <tr>
            <td class='text-center px-4 py-2 font-bold border'>Date</td>
            <td class='text-center border'>Type</td>
            <td class='text-center border'>Amount</td>
            <td class='text-center border'>Transfer Balance <br />Account</td>
            <td class='text-center border'>Personal Transfer <br />Balance Cap</td>
            <td class='text-center border'>Transfer Balance<br />Cap Remaining</td>
            <td class='text-center border'>Used Cap %</td>
          </tr>
          </thead>
          <tr v-for='(transaction, index) in transactions' :key='index'>
            <td class='pl-4'>{{ transaction.date | moment('D MMM YYYY') }}</td>
            <td class='pl-4'>{{ transaction.event }}</td>
            <td class='vgt-row-header text-right'>
              <div class='float-right'><div v-if="transaction.type === 'debit'" class='float-left'>-</div>
              {{ transaction.amount | dollar }}</div>
            </td>
            <td class='text-right px-4 py-3'>
              <div v-if='transaction.TBA_RUNNING_BALANCE'>{{ transaction.TBA_RUNNING_BALANCE | dollar }}</div>
              <div v-else>-</div>
            </td>
            <td class='text-right px-4'>
              <div v-if='transaction.PERSONAL_TBC'>{{ transaction.PERSONAL_TBC | dollar }}</div>
              <div v-else>-</div>
            </td>
            <td class='text-right px-4'>
              <div v-if='transaction.REMAINING_TBC'>{{ transaction.REMAINING_TBC | dollar }}</div>
              <div v-else>-</div>
            </td>
            <td class='text-right px-4'>
              <div v-if='transaction.USED_TBC_CAP'>{{ transaction.USED_TBC_CAP | percent }}</div>
              <div v-else>-</div>
            </td>
          </tr>
        </table>
      </div>
      <div class="float-left w-full mt-4">
        <hr class="w-3/4 border-2">
      </div>
      <div class="w-full flex flex-col">
        <div class="flex w-3/4 mt-4 text-xs text-gray-500">
          <p>The calculation above is believed to be accurate based on legislation in force at the time of preparation and the information entered above.</p>
        </div>
        <div class="flex w-3/4 mt-4 text-xs text-gray-500">
          <p>It should not be regarded as personal financial product advice and is provided to assist advisors and accountants in advising their clients. For information about the calculations and how Heffron can support you further, please contact us on 1300 433 376 or on <a href='mailto:heffron@heffron.com.au'>heffron@heffron.com.au</a></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'transfer-balance-cap-pdf',
  props: {
    indexations: {
      type: Array,
      default: () => ([]),
    },
    name: {
      type: String,
      required: true,
    },
    transactions: {
      type: Array,
      default: () => ([]),
    },
    preparedOn: {
      type: Date,
      required: true,
    },
  },
};
</script>

<style>

</style>
